import React from 'react';
import { useI18nContext, Trans } from '@ecg-marktplaats/js-react-i18n';
import { currency } from '@ecg-marktplaats/aurora-js-formatters';

import Classes from './Price.module.scss';

type TPriceProps = {
  price: number | undefined;
};

const Price = ({ price }: TPriceProps) => {
  const { t } = useI18nContext();

  if (!Number.isFinite(price)) {
    return <p className={Classes.otherPrice}>{t('listing.trustIndicators.warranties.price.unknown')}</p>;
  }

  if (price === 0) {
    return <p className={Classes.includedPrice}>{t('listing.trustIndicators.warranties.price.included')}</p>;
  }

  const formattedPrice = currency(price as number, true);

  return (
    <p className={Classes.otherPrice}>
      <Trans i18nKey="listing.trustIndicators.warranties.price.optional" price={formattedPrice} tagName="span" />
    </p>
  );
};

export default Price;
